import { render } from "./ColumnResource.vue?vue&type=template&id=8c7e6c0e&scoped=true&ts=true"
import script from "./ColumnResource.vue?vue&type=script&lang=ts"
export * from "./ColumnResource.vue?vue&type=script&lang=ts"

import "./ColumnResource.vue?vue&type=style&index=0&id=8c7e6c0e&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c7e6c0e"]])

export default __exports__